// utils/taskStatus.js
import axios from "axios";

/**
 * Fetch latest status for a "reference-based" task
 * (Work Permit, ADC, CVSA, Vacation, etc.)
 *
 * This ALWAYS sets status by both:
 *  - task key  (e.g. "work_permit")
 *  - task id   (e.g. "40")
 *
 * so UserHome icon logic works reliably.
 */
export async function fetchLatestTaskStatus({
  baseUrl,
  userId,
  endpoint, // e.g. "/api/workpermit/latest/status"
  taskId, // number (40, 57, etc.)
  taskKey, // string ("work_permit", "annual_driver_certification")
  token,
  baseStatus,
}) {
  if (!baseUrl || !userId || !endpoint || !taskId || !taskKey) {
    console.warn("⚠️ fetchLatestTaskStatus: missing required params", {
      baseUrl,
      userId,
      endpoint,
      taskId,
      taskKey,
    });
    return;
  }

  try {
    const res = await axios.get(`${baseUrl}${endpoint}/${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const status = res?.data?.status || "not_completed";

    // 🔑 critical: set BOTH key and id
    baseStatus[taskKey] = status;
    baseStatus[String(taskId)] = status;
  } catch (err) {
    console.error(
      `❌ Failed to fetch latest status for ${taskKey} (taskId=${taskId})`,
      err
    );
  }
}
